/**
 * PostHog 初期化 (Phase 3).
 *
 * 行動ログ + フィードバック収集。
 * API Key は環境変数 VITE_POSTHOG_KEY で注入。
 * 未設定時は noop（開発時にログを汚さない）。
 */

import posthog from 'posthog-js';

const POSTHOG_KEY =
  (import.meta as unknown as { env?: { VITE_POSTHOG_KEY?: string } }).env?.VITE_POSTHOG_KEY ?? '';

const POSTHOG_HOST =
  (import.meta as unknown as { env?: { VITE_POSTHOG_HOST?: string } }).env?.VITE_POSTHOG_HOST ??
  'https://us.i.posthog.com';

let initialized = false;

export function initPostHog(): void {
  if (initialized || !POSTHOG_KEY) return;

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    // SPA なので手動で pageview を送る
    capture_pageview: false,
    // セッション録画は Phase 7+ で検討
    disable_session_recording: true,
    // Cookie 同意前はオプトアウト
    persistence: 'localStorage',
    // PII は送らない
    sanitize_properties: (properties) => {
      // email 等が混入しないよう、$set/$set_once は除去
      delete properties.$set;
      delete properties.$set_once;
      return properties;
    },
  });

  initialized = true;
}

/**
 * ページビューを送信。TanStack Router の onRouteChange で呼ぶ。
 */
export function trackPageView(path: string): void {
  if (!POSTHOG_KEY) return;
  posthog.capture('$pageview', { $current_url: path });
}

/**
 * カスタムイベントを送信。
 */
export function trackEvent(event: string, properties?: Record<string, unknown>): void {
  if (!POSTHOG_KEY) return;
  posthog.capture(event, properties);
}

/**
 * ユーザー識別。ログイン成功時に呼ぶ。
 */
export function identifyUser(userId: string): void {
  if (!POSTHOG_KEY) return;
  posthog.identify(userId);
}

/**
 * ユーザーリセット。ログアウト時に呼ぶ。
 */
export function resetUser(): void {
  if (!POSTHOG_KEY) return;
  posthog.reset();
}
